import { getAttribute } from './getAttribute.ts';

export function extractAdjustmentDescription(
  sale: Element,
  ...adjustmentTypes: string[]
): string | undefined {
  const adjustmentSrc = Array.from(sale.getElementsByTagName('SALE_PRICE_ADJUSTMENT'));
  const adjustmentTag = adjustmentSrc.find((adj) =>
    adjustmentTypes.includes(adj.getAttribute('_Type') ?? ''),
  );
  return getAttribute(adjustmentTag, '_Description');
}
